<template>
	<v-dialog v-model="dialog" persistent max-width="60vw">
		<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor" pa-0></v-toolbar>
		<v-card>
			<v-card-title class="headline">
				<slot name="header">
					default header
				</slot>
			</v-card-title>
			<v-card-text>
				<slot name="body">
					default body
				</slot>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<slot name="footer">
					default footer
				</slot>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default{
		name: 'Modal',
		props: ['dialog'],
		data(){
			return{
				registro: {},
				cor: 'primary',
			}
		},
		methods:{
			salvar(){
				alert('sou')
			}
		},

		created(){
			this.registro = this.$store.state.registro
		}
	}
</script>

<style scoped>
/* .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  width: 100%;

}

div.modal-container {
  
  width: 60%;
  
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border-radius: 6px;
  position: relative;
  
}


img{
	width: 50px;
	height: 50px;
	position: relative;
	left: 50%;
	top: -50%;

}

.modal-header{
	background-image: linear-gradient(to right, var(--cor-secundaria), var(--cor-principal));

}

.modal-header h3 {
	margin-top: 0;
	color: rgb(250, 250, 250);
	font-size: 1.5rem;
	text-align: center;;
	width: 100%;
}

div.modal-body {
	padding: 60px 40px;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}

div.modal-body button{
	z-index: 100;
}

div.modal-body h4{
	text-align: center;
	font-weight: 600;
}

div.modal-footer{
	padding: 10px 20px;
	background-image: linear-gradient(to right, rgba(150, 0, 150, 0.1), rgba(220, 0 ,220, 0.2));
}

div.modal-footer > div{
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	width: 100%;
}
.modal-default-button {
  background-color: rgb(230, 230, 230);
  
  
  border: 0;
  color: rgb(250, 250, 250);
  border-radius: 6px;
  padding: 4px 16px;
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
} */
</style>